function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    repost\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.46,30.54H9.17A1.84,1.84,0,0,1,7.33,28.7V16.26a1.84,1.84,0,1,1,3.68,0v10.6h9.45a1.84,1.84,0,1,1,0,3.68Z"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "1.34 20.15 9.17 9.55 17 20.15 1.34 20.15"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.54,11.39H30.83a1.84,1.84,0,0,1,1.84,1.84V25.67a1.84,1.84,0,0,1-3.68,0V15.07H19.54a1.84,1.84,0,1,1,0-3.68Z"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "38.66 21.78 30.83 32.38 23 21.78 38.66 21.78"
});

function SvgRepost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "repost_svg__repost_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgRepost;